import gql from "graphql-tag";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import { MagicLinkPurpose } from "@rmh/defs";

interface RequestMagicLinkVariables {
  email: string;
  purpose: MagicLinkPurpose;
  callbackUrl?: string;
}

interface RequestMagicLinkResponse {
  requestMagicLink: boolean | null;
}

const requestMagicLinkMutation = gql`
  mutation RequestMagicLink(
    $email: String!
    $purpose: String
    $callbackUrl: String
  ) {
    requestMagicLink(
      email: $email
      purpose: $purpose
      callbackUrl: $callbackUrl
    )
  }
`.loc?.source.body as GeneratedMutation<
  RequestMagicLinkVariables,
  RequestMagicLinkResponse
>;

/**
 * @param callbackUrl locale-stripped in-app path to land on after sign-in. The
 * lambda validates it against the patient route table and drops anything else,
 * so passing an unvalidated value is safe but pointless.
 */
export async function requestMagicLink(
  email: string,
  purpose: MagicLinkPurpose = MagicLinkPurpose.SignIn,
  callbackUrl?: string
): Promise<void> {
  // Unauthenticated request step for the logged-out magic-link sign-in flow.
  const client = generateClient({ authMode: "apiKey" });

  await client.graphql({
    query: requestMagicLinkMutation,
    variables: { email, purpose, callbackUrl },
  });
}
